import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=b898aada&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=b898aada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b898aada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b898aada')) {
      api.createRecord('b898aada', component.options)
    } else {
      api.reload('b898aada', component.options)
    }
    module.hot.accept("./Avatar.vue?vue&type=template&id=b898aada&scoped=true&", function () {
      api.rerender('b898aada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Layout/Avatar.vue"
export default component.exports